import { render, staticRenderFns } from "./RssFeeds.vue?vue&type=template&id=647c8f2d&scoped=true&"
import script from "./RssFeeds.vue?vue&type=script&lang=js&"
export * from "./RssFeeds.vue?vue&type=script&lang=js&"
import style0 from "./RssFeeds.vue?vue&type=style&index=0&id=647c8f2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c8f2d",
  null
  
)

export default component.exports